import React, { useEffect, useState } from "react";
import "./processors/process.scss";
import { Col, Form } from "react-bootstrap";
import Select from "react-select";
import { getEquipments, saveOrgEquipment } from "../../../api";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

function OrganizationEquipment({ organization_id, organization_data }) {
    const [equipments, setEquipments] = useState([]);
    const [selected_equipments, setSelectedEquipments] = useState([]);
    const [error, setError] = useState([]);

    useEffect(() => {
        getEquipments().then((response) => {
            if (response.status) {
                const equipment_options = response.data.equipments.map(
                    (equipment) => {
                        return {
                            label: equipment.equipment_name,
                            value: equipment.id,
                        };
                    },
                );
                setEquipments(equipment_options);
            }
        });
    }, []);

    useEffect(() => {
        if (organization_data.equipments) {
            let Equipments = organization_data.equipments;
            let selectedEquipments = [];
            Equipments.forEach((id) => {
                equipments.forEach((equipment) => {
                    if (equipment.value == id) {
                        selectedEquipments.push(equipment);
                    }
                });
            });

            setSelectedEquipments(selectedEquipments);
        }
    }, [equipments]);

    const submit = () => {
        if (selected_equipments.length == 0) {
            setError(["Please select equipment"]);
            return;
        }
        saveOrgEquipment({
            equipments: selected_equipments,
            organization_id: organization_id,
        }).then((response) => {
            if (response.status) {
                MySwal.fire({
                    title: <p>{"Equipment saved successfully."}</p>,
                    icon: "success",
                    toast: true,
                    position: "top-end",
                    timer: 4000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    customClass: "margin-top-sweetalert",
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                });
                setError([]);
            }
        });
    };

    return (
        <div className="row bank-process">
            <div className="col-12 col-md-12 col-lg-12">
                <form id="org-process-form">
                    <h5 className="title">Organization Equipments</h5>
                    <Form.Row>
                        <Form.Group as={Col} xs={12} className="px-3">
                            <Select
                                isMulti
                                name="org_equipments"
                                placeholder=""
                                options={equipments}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                value={selected_equipments}
                                onChange={(selectedOptions) =>
                                    setSelectedEquipments(selectedOptions)
                                }
                            />
                            <label className="modal-lab">Equipments</label>
                            {error.length > 0 && (
                                <Form.Control.Feedback
                                    type="invalid"
                                    className="text-capitalize"
                                >
                                    {" "}
                                    {error}{" "}
                                </Form.Control.Feedback>
                            )}
                        </Form.Group>
                    </Form.Row>
                </form>

                <button
                    form="org-process-form"
                    type="button"
                    onClick={() => submit()}
                    className="btn float-right confirm-button"
                >
                    {" "}
                    Save
                </button>
            </div>
        </div>
    );
}

export default OrganizationEquipment;
